import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "feedback"]

  connect() {
    this.format()
  }

  format() {
    let value = this.inputTarget.value.replace(/\D/g, "")

    if (value.length <= 11) {
      // CPF
      value = value
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    } else {
      // CNPJ
      value = value
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2")
    }

    this.inputTarget.value = value.slice(0, 18)

    this.validate()
  }

  validate() {
    const raw = this.inputTarget.value.replace(/\D/g, "")

    if (raw.length === 0) {
      this.clear()
      return
    }

    if (raw.length !== 11 && raw.length !== 14) {
      this.invalidate("CPF ou CNPJ incompleto")
      return
    }

    fetch(`/validate_tax_id?value=${raw}`)
      .then(r => r.json())
      .then(data => {
        if (data.valid) {
          this.valid()
        } else {
          this.invalidate("CPF ou CNPJ inválido")
        }
      })
  }

  valid() {
    this.inputTarget.classList.remove("is-invalid")
    this.inputTarget.classList.add("is-valid")
    if (this.hasFeedbackTarget) this.feedbackTarget.textContent = ""
  }

  invalidate(message) {
    this.inputTarget.classList.add("is-invalid")
    this.inputTarget.classList.remove("is-valid")
    if (this.hasFeedbackTarget) this.feedbackTarget.textContent = message
  }

  clear() {
    this.inputTarget.classList.remove("is-invalid", "is-valid")
    if (this.hasFeedbackTarget) this.feedbackTarget.textContent = ""
  }
}